import { useQuery } from '@tanstack/react-query';

import { ListQueryParams, MyBookingsResponseData } from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const MY_BOOKINGS_QUERY_KEY = 'my_bookings';

export const useMyBookingsQuery = (url: string, queryParams: ListQueryParams) =>
  useQuery({
    queryKey: [MY_BOOKINGS_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<MyBookingsResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
  });
